module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/top/img_result11-7671b19b397d43458a1498931ede8cf7.png";